import { render, staticRenderFns } from "./ArticleForm.vue?vue&type=template&id=2b544efc&scoped=true"
import script from "./ArticleForm.vue?vue&type=script&lang=js"
export * from "./ArticleForm.vue?vue&type=script&lang=js"
import style0 from "./ArticleForm.vue?vue&type=style&index=0&id=2b544efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b544efc",
  null
  
)

export default component.exports